// Dimensions are in pixels but will be converted in rem
export const contentWidth = 1366;
export const leftBar = 320;
